var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('one-column-row',[_c('v-card',{attrs:{"tile":"","loading":_vm.isLoading}},[_c('v-card-text',[_c('SubmissionList',{attrs:{"model-name":"submission"}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }